import React from 'react';
var ViewFilterQueryContext = /*#__PURE__*/React.createContext(null);
export default ViewFilterQueryContext;